import { useReduxSelector } from 'hooks';

export default function useLegacyNavigationPayload() {
  return useReduxSelector((state) => ({
    baseUrl: state.environment.REACT_APP_LEGACY_URL,
    token: state.authentication.token,
  }));
}
